export function stageLabel(n: number) {
  if (n >= 3) return "Stage 3";
  if (n === 2) return "Stage 2";
  if (n === 1) return "Stage 1";
  return "None";
}
